import max from 'ramda/src/max';
import compose from 'ramda/src/compose';
import replace from 'ramda/src/replace';
import {toCurrency} from '@util/NumberUtil';

const check = function ( str ) {
    if ( typeof str !== 'string' ) {
        try {
            str = new String( str );
        }
        catch ( err ) {
            console.error( `Invalid argument: StringUtils requires a string argument but received ${str} instead` );
            str = '';
        }
    }

    return str;
};

export const validatePostalCode = function ( postalCode ) {
    const regex = /^\d{5}(-\d{4})?$/;
    return regex.test( postalCode );
};

export const validateEmail = function ( email ) {
    const str = check( email );

    const re = /^\S+@\S+$/;
    return re.test( str );
};

export const toTitleCase = ( s ) => {
    const str = check( s );

    return str.replace( /\w\S*/g, ( txt ) => {
        return txt.charAt( 0 ).toUpperCase() + txt.substr( 1 ).toLowerCase();
    } );
};

export function formatPrice(price) {
    if (price === 0) {
        return 'Free';
    }

    return `$${toCurrency(parseFloat(price, 10))}`;
}

export const toSnakeCase = (s) => {
    const str = check(s);

    return str.replace(/\s/g, '_').toLowerCase();
}



export function formatPhoneUS(phoneNumber) {
    const match = /(\d{3})(\d{3})(\d{4})/.exec( phoneNumber );
    if ( !match || match.length !== 4 ) {
        return phoneNumber;
    }

    return `(${match[1]}) ${match[2]}-${match[3]}`;
}

export function trimFormData ( obj = {} ) {
    const newObj = {};

    for ( let key in obj ) {
        if ( typeof obj[key] !== 'string' ) {
            newObj[key] = obj[key];
            continue;
        }
        newObj[key] = obj[key].trim();
    }

    return newObj;
}

export function reverseString ( s ) {
    const str = check( s );
    return str.split( '' ).reverse().join( '' );
}

export function truncateStringByChar ( s, maxLen = 100 ) {
    const str = check( s );

    const len = max( 0, maxLen );
    if ( str.length > len ) {
        // find last word boundary starting at specified length and trim
        return str.substr( 0, len ).replace( /\s+\w+$/, '' );
    }

    return str;
}

export function truncateStringByLine ( s, maxLen = 3 ) {
    const str = check( s );

    // match lines with at least 1 carriage return
    const matchedLines = str.match( /.*[\r\n]{1,2}/gm );
    const len = max( 0, maxLen );
    if ( matchedLines && matchedLines.length >= len ) {
        return matchedLines
            .slice( 0, len )
            .reduce( ( acc, next ) => acc += next, '' )
            .trim();
    }

    return str;
}

export function truncateString ( s, maxCharLen, maxLineLen ) {
    const str = check( s );

    return truncateStringByChar(
        truncateStringByLine( str, maxLineLen ),
        maxCharLen
    );
}

// only replace "-" or "/" that appear between words (word chars) leaving other values
// such as SKU or Serial Numbers unchanged that may have a combination of numbers and word chars
export const wordsFromSlug = compose( replace( /(?!=[a-z][^0-9]+)[-/](?=[a-z][^0-9]+)/gi, ' ' ), decodeURIComponent );

export const toTitleFromSlug = compose( toTitleCase, wordsFromSlug );
